<template>
  <transition
    name="fade-shrink-in"
    appear
  >
    <div
      v-show="open"
      class="flex flex-col justify-center absolute top-0 right-0 w-screen h-screen"
      style="z-index: 9999; background-color: rgba(0,0,0,0.5); backdrop-filter: blur(2px)"
      @click="close"
    >
      <div
        :class="`modal-content w-11/12 ${type !== 'custom' ? 'max-w-sm' : 'max-w-4xl'} mx-auto bg-white rounded-lg ${type !== 'custom' ? 'p-6' : ''} my-8 z-10 shadow-lg max-h-screen overflow-y-auto`"
        @click.stop
      >
        <div
          v-if="type==='preloader'"
        >
          <svg
            id="loader"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r="45"
            />
          </svg>
        </div>
        <slot name="content" />
        <div
          v-if="type==='confirm'"
          class="flex justify-between items-center mt-8 px-2 text-lg"
        >
          <a
            class="text-purple-500 hover:underline"
            @click="close"
          >
            {{ cancelText || 'cancelar' }}
          </a>
          <a
            id="recaptcha-container"
            class="notranslate text-white bg-purple-500 p-4 rounded-md font-semibold hover:underline"
            @click="$emit('confirm')"
          >
            {{ okText || 'Ok' }}
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    open: Boolean,
    type: { type: String, default: 'confirm' },
    okText: { type: String, default: '' },
    cancelText: { type: String, default: '' },
  },
  created () {
    document.addEventListener('keydown', (e) => {
      if (this.open && e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../css/_brand";
.fade-shrink-in-enter-active,
.fade-shrink-in-leave-active {
  transition: all .3s ease;
}

.fade-shrink-in-enter,
.fade-shrink-in-leave-to {
  opacity: 0;
  transform: scale(1.1);
}
#loader {
  animation: 2s linear infinite svg-animation;
  max-width: 50px;
  margin: 0 auto 20px auto;
}

// SVG animation.
@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

// Circle styles.
circle {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: $primary-color;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

// Circle animation.
@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }
  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
